import { axios } from '../helpers/axios'
import { ClientSetting } from './DataTypes'

export async function getUserLanguage() {
  const { data } = await axios.get('/api/User/Language')

  return data
}

// these next 2 are unused, future changes will have them moved to featurebinary somehow
export async function getClientSettings(clientId): Promise<ClientSetting[]> {
  const { data } = await axios.get(`/api/Client/${clientId}/GetClientSettings`)

  return data
}

export async function getUserClientSettings() {
  const { data } = await axios.get('/api/User/GetUserClientSettings')

  return data
}

export async function getCodeVersion() {
  const { data } = await axios.get('/api/CodeVersion')

  return data
}
export async function globalAlert(key) {
  const { data } = await axios.get('/api/alert')

  return data
}
